import React, {useEffect, useCallback, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Splide, SplideSlide} from '@splidejs/react-splide';
import Plyr from 'plyr-react'
import PrismaZoom from 'react-prismazoom';
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';

import GlobalConst from '../../../common/global-const';

import SocialNetworks from '../../../common/component/SocialNetworks/SocialNetworks';

import {Container, Row, Col, Button, Nav} from 'react-bootstrap';

import {ReactComponent as ImgCustomerClub} from '../../../asset/img/icon/customer-club.svg';
import * as IconFi from 'react-icons/fi';
import * as IconTb from 'react-icons/tb';

const Place2 = props => {
    const refPrismaZoom = useRef();
    const refLightGallery = useRef();
    const navigate = useNavigate()

    const data = props.data

    // ---------------------------------------------------------------------------------------------------------- splide

    const slideshowProductsOptions = {...GlobalConst.splide, type: null, perPage: 6,
        breakpoints: {
            1200: {
                perPage: 5
            },
            992: {
                perPage: 4
            },
            576: {
                perPage: 3
            }
        }
    }

    const slideshowOptions = {...GlobalConst.splide, padding: 0,
        breakpoints: {
            576: {
                padding: '1.25rem'
            }
        }
    }

    // ------------------------------------------------------------------------------------------------------------ plyr

    const videoRef = useCallback(node => {
        if (node !== null && node.plyr.toggleControls) {
            node.plyr.toggleControls(false);
            node.plyr.on('play', () => node.plyr.config.hideControls = true);
        }
    }, []);

    // ------------------------------------------------------------------------------------------------------------- map

    useEffect(() => {

        let timeout = setTimeout(() => {

            let $prismaZoom = document.querySelector('#pagePlace .prisma-zoom');
            let $path = $prismaZoom.querySelector(`svg path#path${data.shop.shopNumber}`);

            if ($path) {
                const x = $path.getBoundingClientRect().left - $prismaZoom.getBoundingClientRect().left
                const y = $path.getBoundingClientRect().top - $prismaZoom.getBoundingClientRect().top
                const width = $path.getBoundingClientRect().width
                const height = $path.getBoundingClientRect().height

                refPrismaZoom.current.zoomToZone(x, y, width, height)
            }

        }, 1000)

        return () => clearTimeout(timeout)

    }, [])

    const zoomIn = () => {
        refPrismaZoom.current.zoomIn(1)
    }

    const zoomOut = () => {
        refPrismaZoom.current.zoomOut(1)
    }

    // --------------------------------------------------------------------------------------------------- light gallery

    const onInitHandler = useCallback(e => {

        if (e) refLightGallery.current = e.instance;

    }, [])

    const handlePopstate = useCallback(() => {

        window.removeEventListener('popstate', handlePopstate)

        refLightGallery.current.closeGallery();

    }, [])

    const showMenuHandler = useCallback(() => {

        window.addEventListener('popstate', handlePopstate);

        navigate(`#galleryMenu`);

        refLightGallery.current.openGallery();

    }, [])

    const hideMenuHandler = useCallback(() => {

        // اگر با دکمه gallery بسته شد در hash مقدار galleryMenu وجود دارد
        if (window.location.hash.includes('#galleryMenu')) {

            // اگر با دکمه gallery بسته شد
            window.removeEventListener('popstate', handlePopstate)

            navigate(-1);

        }

    }, [])

    const setGalleryTitleHandler = useCallback(() => {

        if (!document.querySelector('.lg-container .lg-toolbar .modal-title')) {
            let $target = document.querySelector('.lg-container .lg-toolbar .lg-close')

            let $title = document.createElement('div')
            $title.classList.add('flex-grow-1', 'text-center', 'text-truncate', 'h5', 'modal-title');
            $title.innerHTML = `منو ${data.shop.title}`;

            $target.parentNode.insertBefore($title, $target.nextSibling)
        }

    }, [])

    const prevSlideBugFixHandler = useCallback(e => {

        if (e.index === 2 && data.restaurantMenu.length > 3)
            document.querySelector('.lg-inner > div:nth-child(4)').innerHTML = document.querySelector('.lg-inner > div:nth-child(3)').innerHTML

    }, [])

    const customGalleryCounterHandler = useCallback(e => {

        document.querySelector('.lg-counter').innerHTML = `${e.index === 0 ? 1 : data.restaurantMenu.length - e.index + 1}/${data.restaurantMenu.length}`

    }, [])

    // برای اینکه با هر رندر از ابتدا ساخته نشود
    const [renderLightGallery, setRenderLightGallery] = useState(<LightGallery plugins={[lgZoom]} mobileSettings={{controls: false, showCloseIcon: true, closeOnTap: false}} download={false} actualSize={false}
                                                                               onBeforeOpen={() => document.querySelector('body').classList.add('modal-open')}
                                                                               onAfterOpen={() => setGalleryTitleHandler()}
                                                                               onAfterAppendSlide={prevSlideBugFixHandler}
                                                                               onBeforeSlide={customGalleryCounterHandler}
                                                                               onBeforeClose={() => hideMenuHandler()}
                                                                               onAfterClose={() => document.querySelector('body').classList.remove('modal-open')}
                                                                               dynamicEl={data.restaurantMenu.map(item => {return {src: `${GlobalConst.cdn}${item.path}`}})} dynamic onInit={onInitHandler}/>)

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <section id="banner" className="position-relative">
                <div className="position-absolute top-0 end-0 bottom-0 start-0 bg-primary bg-opacity-12 z-index-n1">
                    <picture className="d-block mx-auto h-100 filter-warm">
                        <span className="filter-level"/>
                        <source media="(max-width:767px)" srcSet={`${GlobalConst.cdn}${data.smallCover?.path}`}/>
                        <img src={`${GlobalConst.cdn}${data.mainCover?.path}`} alt="" className="h-100 w-100 object-fit-cover"/>
                        <span className="filter-gradient"/>
                    </picture>
                </div>
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="d-flex flex-column align-items-center mt-5 pt-5 pb-4">
                            <h1 className={`mt-5 pt-4 display-2 fw-bold ls-1 ws-n1${data.club ? '' : ' mb-4'}`}>{data.shop.title}</h1>
                            {
                                data.club && (
                                    <div className="mb-4">
                                        <Button variant="secondary" as={Link} to="/customer-club" id="customerClub" className="px-4 border-0">
                                            <ImgCustomerClub fill="var(--bs-accent-3)" strokeWidth="0"/>
                                            <span className="ms-2 me-sm-1 fs-9 ws-n1 text-nowrap text-accent-3">عضو باشگاه مشتریان</span>
                                        </Button>
                                    </div>
                                )
                            }
                            {
                                (data.shop.workHour[0] || data.shop.workHour[1]) && (
                                    <>
                                        <span className="mb-lg-3 fs-8">ساعـات کار</span>
                                        <p className="d-flex flex-column align-items-center mb-2 mt-1 working-hours">
                                            {
                                                data.shop.workHour[0] && (
                                                    <span className="fs-5 lh-1" dangerouslySetInnerHTML={{__html: data.shop.workHour[0].includes('-') ? data.shop.workHour[0].replace('-','<span>تا</span>') : data.shop.workHour[0]}}/>
                                                )
                                            }
                                            {
                                                data.shop.workHour[1] && (
                                                    <span className="fs-5 lh-1" dangerouslySetInnerHTML={{__html: data.shop.workHour[1].includes('-') ? data.shop.workHour[1].replace('-','<span>تا</span>') : data.shop.workHour[1]}}/>
                                                )
                                            }
                                        </p>
                                    </>
                                )
                            }
                            <span className="fs-5 ls-half">طبقه {data.floor.title} غرفه <span className="ls-1 font-fa">{data.shop.shopNumber}</span></span>
                            <Button href={`tel:+98${data.shop.phones[0]}`} variant="link" className="flex-column align-items-center text-center p-0 text-reset text-decoration-none mt-4">
                                <span className="bg-primary bg-opacity-60 p-1 mb-2 rounded-square">
                                    <IconFi.FiPhone size={24} className="sw-1 m-2 flip-h"/>
                                </span>
                                <span className="fw-normal lh-sm fs-9">تـمـاس</span>
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Container id="box" fluid="lg" as="section" className="pb-4 pb-xl-5">
                <Row className="g-0">
                    <Col lg={7} id="map">
                        <div className="ratio ratio-7x5 bg-secondary overflow-hidden position-relative h-100">
                            <style dangerouslySetInnerHTML={{__html: `#pagePlace .prisma-zoom svg path#path${data.shop.shopNumber} {fill: #ffffff !important}`}}/>
                            <PrismaZoom className="d-flex justify-content-center align-items-center prisma-zoom" ref={refPrismaZoom} allowTouchEvents maxZoom={3}>
                                <div dangerouslySetInnerHTML={{__html: data.map}}/>
                            </PrismaZoom>
                            <div className="d-flex flex-column shadow-sm border-top border-black-3 bg-white position-absolute start-0 bottom-0 z-index-1 zoom">
                                <Button variant="link" className="text-secondary btn-icon" onClick={zoomIn}><IconFi.FiPlus size={24} className="sw-1"/></Button>
                                <hr className="my-0"/>
                                <Button variant="link" className="text-secondary btn-icon" onClick={zoomOut}><IconFi.FiMinus size={24} className="sw-1"/></Button>
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className="p-5 order-first order-lg-0 bg-primary bg-opacity-12">
                        <p className="mb-0" dangerouslySetInnerHTML={{__html: data.shop.content}}/>
                        {
                            data.shop.networkAddresses.length && (
                                <Nav className="mx-n2 mt-3 lh-1">
                                    <SocialNetworks data={data.shop.networkAddresses}/>
                                </Nav>
                            )
                        }
                    </Col>
                    {
                        data.restaurantMenu?.length ? (
                            <>
                                <Col xs={12} className="order-first order-lg-0">
                                    <div className="pb-5 pt-4 bg-elevate-1 d-flex flex-column align-items-center justify-content-center">
                                        <IconTb.TbGlassFull size={48} className="sw-1 mb-1 mt-2 mt-lg-0"/>
                                        <p className="fs-4 fw-normal">مـنـو {data.shop.title}</p>
                                        <Button variant="link" className="bg-primary bg-opacity-38 text-decoration-none text-reset px-5" onClick={() => showMenuHandler()}>مشاهده</Button>
                                    </div>
                                </Col>
                                <div className="invisible">{renderLightGallery}</div>
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {
                        data.products ? (
                            <Col xs={12}>
                                <div className="shadow-sm slideshow">
                                    <Splide options={slideshowProductsOptions}>
                                        {
                                            data.products.map(item => {
                                                return (
                                                    <SplideSlide key={item.id}>
                                                        <figure className="ratio ratio-1x1 mb-0">
                                                            <img src={`${GlobalConst.cdn}${item.photos[0].path}`} alt="" className="w-100 h-100 object-fit-cover"/>
                                                        </figure>
                                                    </SplideSlide>
                                                )
                                            })
                                        }
                                    </Splide>
                                </div>
                            </Col>
                        ) : (
                            <></>
                        )
                    }
                    <Col md={6} id="video">
                        <div className={`ratio ratio-4x3 bg-accent overflow-hidden${data.video ? '' : ' blank'}`}>
                            {
                                data.video ? (
                                    <Plyr source={{type: 'video', sources: [{src: `${GlobalConst.cdn}${data.video?.path}`, type: 'video/mp4'}], poster: `${GlobalConst.cdn}${data.videoCover?.path}`}} options={GlobalConst.plyr} ref={videoRef}/>
                                ) : (
                                    <div className="text-primary px-5 py-4 text-center d-flex align-items-center justify-content-center fs-5 h-100 ws-n1">در حال حاضر ویدیویی وجود ندارد</div>
                                )
                            }
                        </div>
                    </Col>
                    <Col md={6} className="gallery">
                        <div className={`ratio ratio-4x3 ${data.gallery.length ? '' : ' blank'}`}>
                            {
                                data.gallery.length ? (
                                    <div className="bg-primary bg-opacity-38 slideshow">
                                            <Splide options={slideshowOptions}>
                                                {
                                                    data.gallery.map(item => {
                                                        return (
                                                            <SplideSlide className="position-relative" key={item.id}>
                                                                <figure className="mb-0 position-absolute top-0 end-0 bottom-0 start-0 mx-2 mx-sm-0 filter-warm">
                                                                    <span className="filter-level"/>
                                                                    <img src={`${GlobalConst.cdn}${item.path}`} alt="" className="w-100 h-100 object-fit-cover"/>
                                                                </figure>
                                                            </SplideSlide>
                                                        )
                                                    })
                                                }
                                            </Splide>
                                        </div>
                                ) : (
                                    <div className="bg-accent-2 px-5 py-4 text-center d-flex align-items-center justify-content-center fs-5 h-100 ws-n1 text-primary">در حال حاضر گالری وجود ندارد</div>
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Place2;